import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileSelectorViewModel, ServerSideDataLoader } from "uicomponents";
import { BalanceTuningRequestViewModel, lineItem } from "./balanceTuningRequest-viewModel";

export class BalanceTuningRequestView extends View<BalanceTuningRequestViewModel>{
    GetViewUniqueId(): string {
        return "V-FEBF7CA3-E86D-44FC-9C8A-A871B79CC82F"
    }
    loadHtml(): string {
        let element = require('./balanceTuningRequest.html').default;
        let style = require('./balanceTuningRequest.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    async createRequest(){
        this.dataContext.createRequest();
    }

    async import(){
        this.dataContext.import();
    }

    createRequestsBatch(){
        this.dataContext.createRequestsBatch();
    }

    returnLowSales(){
        this.dataContext.returnLowSales();
    }
}
